import React from 'react';
import './ExploreCampus.css';

const ExploreCampus = () => {
  const features = [
    {
      id: 1,
      text: "Smart\nClassrooms",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="12" rx="2" ry="2"></rect>
          <path d="M12 15v4"></path>
          <path d="M8 19h8"></path>
          <path d="M7 11h10"></path>
        </svg>
      )
    },
    {
      id: 2,
      text: "Computer\nLabs",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
        </svg>
      )
    },
    {
      id: 3,
      text: "Library &\nLearning Resources",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
        </svg>
      )
    },
    {
      id: 4,
      text: "Seminar\nHall",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      )
    },
    {
      id: 5,
      text: "Innovation\nSpaces",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 18h6"></path>
          <path d="M10 22h4"></path>
          <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1.45.62 2.84 1.5 3.5.76.76 1.23 1.52 1.41 2.5"></path>
        </svg>
      )
    }
  ];

  return (
    <section className="ec-campus-section">
      <div className="ec-container">
        
        {/* Header Section */}
        <div className="ec-header">
            <div className="rs5865f2-titleRow">
          <div className="rs5865f2-titlePlain">Explore Our</div>
          <div className="rs5865f2-titleGradient">Campus</div>
        </div>
    <div className="rs5865f2-gradientLine" />
        </div>

        {/* Video Section with Dot Decorations */}
        <div className="ec-video-wrapper">
          <div className="ec-dots ec-dots-top-right"></div>
          <div className="ec-dots ec-dots-bottom-left"></div>
          
          <div className="ec-video-container">
<iframe width="560" height="315" src="https://www.youtube.com/embed/FzEudKf_8Ws?si=obXJAjiqTyvhUAL0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>

<div className="ec-features-container">
          {features.map((feature) => (
            <div key={feature.id} className="ec-feature-card">
              <div className="ec-feature-icon">
                {feature.icon}
              </div>
              <div className="ec-feature-text">
                {feature.text.split('\n').map((line, index) => (
                  <span key={index}>{line}<br/></span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
{/* CTA Button */}
        <div className="ec-cta-container">
          <a href="/facilities/infrastructure" className="ec-btn-outline" style={{ textDecoration: 'none' }}>
            VIEW INFRASTRUCTURE GALLERY <span className="ec-arrow">&gt;</span>
          </a>
        </div>

      </div>
    </section>
  );
};

export default ExploreCampus;